import { render, staticRenderFns } from "./salesGeneralPricingEditor.vue?vue&type=template&id=15b73306&"
import script from "./salesGeneralPricingEditor.vue?vue&type=script&lang=js&"
export * from "./salesGeneralPricingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports